import React from 'react';
import { CustomImage } from '@veneer/core';
import * as T from './types';

const ImageWidget: T.ImageWidgetType = ({ height, size, src, width }) => {
  return <CustomImage {...{ height, size, src, width }} />;
};

export default ImageWidget;
